import type { SchedulingResource } from '../../lib/api.js';

export function detailLabel(resource: SchedulingResource) {
  if (resource.kind === 'PROFESSIONAL') {
    const count = resource.serviceIds.length;
    return count === 0 ? 'Nenhum serviço' : count === 1 ? '1 serviço' : `${count} serviços`;
  }
  return resource.capacity > 1 ? `${resource.capacity} ao mesmo tempo` : '1 por vez';
}
/// Onde as duas espécies aparecem juntas, como no bloqueio, a linha diz qual é qual.
export function resourceKindLabel(resource: SchedulingResource) {
  const kind = resource.kind === 'PROFESSIONAL' ? 'Profissional' : 'Sala';
  return `${kind} · ${detailLabel(resource).toLowerCase()}`;
}
